export default class {
  constructor() {
    this.accordion = document.getElementById('js-accordion');
    this.accordionHiddenItems = document.querySelector('.js-accordionHiddenList');
    this.accordionButton = document.getElementById('js-accordionButton');
  }

  init() {
    if (!this.accordionHiddenItems) return;

    this.accordionButton.addEventListener('click', () => {
      const isExpanded = this.accordionButton.getAttribute('data-expanded') === 'true';
      if (isExpanded) {
        this.accordionHiddenItems.style.maxHeight = '0';
        this.accordionButton.textContent = 'もっとみる';
      } else {
        this.accordionHiddenItems.style.maxHeight = `${this.accordionHiddenItems.scrollHeight}px`;
        this.accordionButton.textContent = 'とじる';
      }
      this.accordionButton.classList.toggle('-up');
      this.accordionButton.setAttribute('data-expanded', !isExpanded);
    });
  }
}
